import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { FormRadioGroup } from '@monorepo/react-components';
import { NyseFormProps } from '../nyse-modal-content';

const NyseStepSix: FunctionComponent<NyseFormProps> = ({ form }) => {
  const { t } = useTranslation(['common', 'contractModal']);

  return (
    <div className={'contracts-steps-body'}>
      <div>
        <p>{t('contractModal:nyse_modal.permitted_receipt')}</p>
        <div>
          <div>
            <p>{t('contractModal:nyse_modal.market_data_usage_question')}</p>
            <FormRadioGroup
              form={form}
              controllerProps={{ name: 'receiveDataNonBusinessUse' }}
              options={[
                {
                  value: false,
                  text: t('common:no'),
                },
                {
                  value: true,
                  text: t('common:yes'),
                },
              ]}
            />
          </div>
          <div>
            <p>
              {t('contractModal:nyse_modal.sec_cftc_registration_question')}
            </p>
            <FormRadioGroup
              form={form}
              controllerProps={{ name: 'hasSECOrCFTC' }}
              options={[
                {
                  value: false,
                  text: t('common:no'),
                },
                {
                  value: true,
                  text: t('common:yes'),
                },
              ]}
            />
          </div>
          <div>
            <p>
              {t('contractModal:nyse_modal.securities_registration_question')}
            </p>
            <FormRadioGroup
              form={form}
              controllerProps={{ name: 'securityAgency' }}
              options={[
                {
                  value: false,
                  text: t('common:no'),
                },
                {
                  value: true,
                  text: t('common:yes'),
                },
              ]}
            />
          </div>
          <div>
            <p>{t('contractModal:nyse_modal.similar_functions_question')}</p>
            <FormRadioGroup
              form={form}
              controllerProps={{ name: 'similarToSECOrCFTC' }}
              options={[
                {
                  value: false,
                  text: t('common:no'),
                },
                {
                  value: true,
                  text: t('common:yes'),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NyseStepSix;
